<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>Badge Application
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>

    <div class="MbDevice">
      <div class="homeLeft mt-5">
        <div class="UserAccount ml-1">
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
        <hr />
        <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
        <div class="expoInfo">
          <p class="bold" name="Exhibition"></p>
          <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
          <p>{{ eExhVenue }}</p>
        </div>
        <p class="clear"></p>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <div class="articleEn">
      <div>
        <Dashboard></Dashboard>

        <div class="contentBox">
          <h1>Badge Application</h1>
          <p class="my-3">&nbsp;</p>

          <div v-if="BadgeStatus">
            <div class="alert text-dark alert-light mb-5" role="alert">
              <div class="font-weight-bold">Notice:</div>
              <ol class="ml-4">
                <li>
                  All exhibitors are required to wear badges as their pass
                  during the move-in, exhibition and move-out periods.
                </li>
                <li>
                  These badges will only be supplied to registered delegates,
                  and will be issued in person at the Exhibition Venue.
                </li>
                <li>Please settle all booth rental before taking badges.</li>
                <li>
                  Application Deadline:<span class="red">
                    {{ BadgeDeadline }}</span
                  >
                </li>
              </ol>
            </div>

            <p class="my-3">&nbsp;</p>

            <div class="PcDevice">
              <div v-if="!Exh_Thai">
                <table
                  class="table table-bordered table-hover w-100"
                  v-if="BadgeList.length > 0"
                >
                  <thead class="thead-light">
                    <tr class="font-weight-bold">
                      <th class="text-start" style="width: 10%">No.</th>
                      <th class="text-center" style="width: 30%">Name</th>
                      <th class="text-center" style="width: 30%">Company</th>
                      <th
                        class="text-center"
                        style="width: 10%"
                        v-if="!DeadlinePassed"
                      >
                        Manage
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in BadgeList" :key="item.BadgeID">
                      <td class="text-start">{{ index + 1 }}.</td>
                      <td class="text-center">
                        <span class="fw-bold">{{ item.Badge_Name }}</span>
                      </td>
                      <td class="text-center">
                        <span class="fw-bold">{{ item.Badge_Company }}</span>
                      </td>
                      <td class="text-center" v-if="!DeadlinePassed">
                        <button
                          type="button"
                          class="btn btn-sm btn-secondary"
                          @click.prevent="deleteBadge(item.BadgeID)"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-else-if="Exh_Thai">
                <table
                  class="table table-bordered table-hover w-100"
                  v-if="BadgeList.length > 0"
                >
                  <thead class="thead-light">
                    <tr class="font-weight-bold">
                      <th class="text-start" style="width: 5%">No.</th>
                      <th class="text-center" style="width: 20%">Name</th>
                      <th class="text-center" style="width: 30%">Company</th>
                      <th class="text-center" style="width: 20%">JobTitle</th>
                      <th class="text-center" style="width: 20%">Email</th>
                      <th
                        class="text-center"
                        style="width: 5%"
                        v-if="!DeadlinePassed"
                      >
                        Manage
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in BadgeList" :key="item.BadgeID">
                      <td class="text-start">{{ index + 1 }}.</td>
                      <td class="text-center">
                        <span class="fw-bold">{{ item.Badge_Name }}</span>
                      </td>
                      <td class="text-center">
                        <span class="fw-bold">{{ item.Badge_Company }}</span>
                      </td>
                      <td class="text-center">
                        <span class="fw-bold">{{ item.Badge_JobTitle }}</span>
                      </td>
                      <td class="text-center">
                        <span class="fw-bold">{{ item.Badge_Email }}</span>
                      </td>
                      <td class="text-center" v-if="!DeadlinePassed">
                        <button
                          type="button"
                          class="btn btn-sm btn-secondary"
                          @click.prevent="deleteBadge(item.BadgeID)"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="text-center mt-4" v-if="!DeadlinePassed">
                <div class="btn btn-primary btn-lg" @click="toAddbadge">
                  Add
                </div>
              </div>
            </div>

            <div class="MbDevice"></div>
          </div>
          <div v-else>
            <p class="mt-4">*Badge Application is currently not open</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import Dashboard from "@/components/Dashboard_en.vue";

export default {
  components: {
    Dashboard,
  },
  metaInfo() {
    return {
      title: `Badge Application - Chan Chao Exhibitor's Online Service System`,
    };
  },

  data() {
    return {
      UserId: "",
      RegNo: "",
      videoList: [],
      videoID: "",
      videoData: [],

      videoType: 3,
      VideoTopic: "",
      eVideoTopic: "",
      videoLink: "",
      videoLink_Youku: "",
      VideoContent: "",
      videoArchive: "0",
      show: false,
      CSRF_Token: "",
      VideoAmount: 0,
      VideoPub: 0,
      lang: "en",
      date: "",

      UploadvideoID: "",
      Serno: "",

      //判斷各頁狀態儀表版值
      OnlineExpolayoutStatus: "",
      PressReleaseStatus: "",
      VideoStatus: "",
      ProductStatus: "",
      BasicinformationStatus: "",

      //判斷儀表板是否有線上展
      HasOnlineExpo: "",
      openOnlineExpo: "",
      showOnlineStatus: false,

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",

      DeadlinePassed: false,
      BadgeDeadline: "",
      Exh_Thai: false,
      BadgeStatus: true,
      BadgeList: [],
    };
  },

  watch: {},

  methods: {
    toAddbadge() {
      const vm = this;

      window.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/BadgeAdd?no=${vm.RegNo}`;
    },

    deleteBadge(id) {
      const vm = this;

      if (confirm("Delete this Badge?")) {
        const info = {
          CSRF: vm.CSRF_Token,
          BadgeID: id,
        };

        const url = `/apiExhibitors/Badge/Delete/${vm.RegNo}`;

        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            location.reload();
          } else if (response.data.Code == 251) {
            alert("Other conditions or sending failed");
          } else if (response.data.Code == 252) {
            alert("CSRF validation failed");
          } else if (response.data.Code == 253) {
            alert("Deletion failed");
          } else if (response.data.Code == 500) {
            alert("The system is busy. Please try again later.");
          }
        });
      } else {
        return false;
      }
    },
  },

  created() {
    const vm = this;

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];
    vm.videoID = currentUrl.split("id=")[1];

    //url取載入頁面參數

    if (vm.lang == "tw") {
      var getHtmlurl = currentUrl.split("/")[4];
      var HtmlName = getHtmlurl.split("?")[0];
    } else {
      //url取英文載入頁面參數
      var getEnHtmlurl = currentUrl.split("/")[5];
      var HtmlEnName = getEnHtmlurl.split("?")[0];
    }

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Badge/List/${vm.RegNo}`)
      .then((response) => {
        if (response.data.Code == 200) {
          vm.BadgeList = response.data.Data.BadgeList;
          vm.BadgeDeadline = response.data.Data.ES_Badge_Deadline;
          let BadgeArchived = response.data.Data.ES_Badge_Archived;

          if (BadgeArchived) {
            vm.BadgeStatus = true;

            //取得時間
            let today = new Date();
            today.setHours(0, 0, 0, 0);

            let deadlineStr = vm.BadgeDeadline.replace(/\//g, "-"); // 轉成安全格式
            let deadline = new Date(deadlineStr);
            deadline.setHours(0, 0, 0, 0);

            if (today > deadline) {
              vm.DeadlinePassed = true;
            } else {
              vm.DeadlinePassed = false;
            }
          } else {
            vm.BadgeStatus = false;
          }
        } else {
          vm.BadgeStatus = false;
        }
      });

    //取得是否開啟線上展權限
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`
      )
      .then((response) => {
        let ExhCode = response.data.Data.Original_Code;
        // 泰國展會更換為多欄位版本
        if (ExhCode == "FPCBTH") {
          vm.Exh_Thai = true;
        } else {
          vm.Exh_Thai = false;
        }
      });
  },
};
</script>

<style lang="scss">
@import "./../../../assets/helper/table.css";
@import "./../../../assets/helper/fancybox.css";

.list-group-item {
  padding: 0.1rem 0.2rem;
}

.table th,
.table td {
  text-align: center;
  vertical-align: middle !important;
}

@media screen and (min-width: 576px) {
  lite-youtube {
    width: 320px;
    height: 180px;
    cursor: pointer;
  }
}

.topUK {
  position: relative;
}

.insideUK {
  position: absolute;
  top: 0;
  right: 0;
  background-color: rgba(162, 166, 167, 0.411);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.uncomplete {
  background-image: url("../../../assets/images/tickGray.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.complete {
  background-image: url("../../../assets/images/tick.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}
</style>
